import styled from "@emotion/styled"

export const Main = styled.main`
  margin: 3rem auto auto auto;
  width: 100%;
  max-width: 600px;
  text-align: center;
`
